export function isNodeSchema(data) {
  return data && data.componentName;
}